import { ListPageType } from '@studyportals/datalake-event-tracker'

const pageTypeMapping: { [key: string]: string } = {
	search: ListPageType.SEARCH,
	studies: ListPageType.STUDY,
	articles: ListPageType.ARTICLE_OVERVIEW,	// plus something else
	'study-options': ListPageType.STUDY_OPTIONS,
	universities: ListPageType.UNIVERSITY,
	account: ListPageType.ACCOUNT,
	countries: ListPageType.COUNTRY,
	disciplines: ListPageType.DISCIPLINE,
	cities: ListPageType.CITY,
	'chat-with-students': ListPageType.UNIBUDDY,
	scholarships: ListPageType.SCHOLARSHIP_OVERVIEW,	// plus something else
	rankings: ListPageType.RANKINGS,
	'rankings-reviews': ListPageType.RANKINGS_REVIEWS,
	'country-test': ListPageType.COUNTRY_TEST,
	'visa-info': ListPageType.VISA_INFO,
};

const getPageTypeOrUrl = (pathname: string): ListPageType | string => {
	if (pathname === '/')
		return ListPageType.HOME;
	else if (pathname === '/scholarships/')
		return ListPageType.SCHOLARSHIP;
	else if (pathname === '/articles/')
		return ListPageType.ARTICLE;
	else if (pathname.startsWith('/universities/scholarships'))
		return ListPageType.UNIVERSITIES_SCHOLARSHIPS;
	else if (pathname.startsWith('/countries/degrees'))
		return ListPageType.COUNTRY_DEGREE;

	const pageType = pathname.split('/');

	if (pageType.length > 1) {
		const page = pageType[1];

		if (page in pageTypeMapping)
			return pageTypeMapping[page] as ListPageType;

		return page;
	}

	return ListPageType.HOME;
}

export { getPageTypeOrUrl };